<template>
  <div>
    <div class="user" v-if="$auth.watch.authenticated">
      <div class="photo">
        <gravatar :email="$auth.user().email" />
      </div>
      <div class="info">
        <a data-toggle="collapse" :aria-expanded="!isClosed" @click="toggleMenu" href="#">
         <span>
           <span v-if="$auth.user().fullName">{{ $auth.user().fullName }}</span>
           <span v-else>{{ $auth.user().username }}</span>
           <b class="caret"></b>
        </span>
        </a>
        <div class="clearfix"></div>
        <div>
          <collapse-transition>
            <ul class="nav nav-menu" v-show="!isClosed">
              <li>
                <a href="javascript:void(0)" @click="$auth.logout({redirect: '/login'})">
                  <span class="sidebar-mini-icon fa fa-lock"></span>
                  <span class="sidebar-normal" v-translate>Logout</span>
                </a>
              </li>
            </ul>
          </collapse-transition>
        </div>
      </div>
    </div>
    <div class="user" v-else>
      <router-link to="/login" class="nav-item" tag="li">
        <a class="nav-link">
          <i class="nc-icon nc-tap-01"></i> <translate>Login</translate>
        </a>
      </router-link>
    </div>

    <brand-selector></brand-selector>
    <event-selector></event-selector>

    <!--<div class="user expostat-event">-->
      <!--&lt;!&ndash;<div class="photo">&ndash;&gt;-->
      <!--&lt;!&ndash;<gravatar email="$auth.user().email" />&ndash;&gt;-->
      <!--&lt;!&ndash;&lt;!&ndash;<img src="static/img/faces/face-2.jpg"/>&ndash;&gt;&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--<div class="info">-->
        <!--<span class="title">Мероприятие:</span>-->
        <!--<a data-toggle="collapse" class="current" :aria-expanded="!eventsIsClosed" @click="eventsIsClosed = !eventsIsClosed" href="javascript:void(0)">-->
             <!--<span>-->
               <!--<span>MVC: Зерно-Комбикорма-Ветеринария 2019</span>-->
               <!--<b class="caret"></b>-->
            <!--</span>-->
        <!--</a>-->
        <!--<div class="clearfix"></div>-->
        <!--&lt;!&ndash;<div>&ndash;&gt;-->
        <!--&lt;!&ndash;<el-collapse-transition>&ndash;&gt;-->
        <!--&lt;!&ndash;<ul class="nav" v-show="!brandsIsClosed">&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;<li>&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;<a href="javascript:void(0)">&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;<span class="sidebar-mini">Mp</span>&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;<span class="sidebar-normal">My Profile</span>&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;</a>&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;</li>&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;<li>&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;<a href="javascript:void(0)">&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;<span class="sidebar-mini">Ep</span>&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;<span class="sidebar-normal">Edit Profile</span>&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;</a>&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;</li>&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;<li>&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;<a href="javascript:void(0)">&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;<span class="sidebar-mini">S</span>&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;<span class="sidebar-normal">Settings</span>&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;</a>&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;&lt;!&ndash;</li>&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;<li>&ndash;&gt;-->
        <!--&lt;!&ndash;<a href="javascript:void(0)" @click="$auth.logout({redirect: '/login'})">&ndash;&gt;-->
        <!--&lt;!&ndash;<span class="sidebar-mini ti-lock"></span>&ndash;&gt;-->
        <!--&lt;!&ndash;<span class="sidebar-normal" v-translate>Logout</span>&ndash;&gt;-->
        <!--&lt;!&ndash;</a>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->
        <!--&lt;!&ndash;</ul>&ndash;&gt;-->
        <!--&lt;!&ndash;</el-collapse-transition>&ndash;&gt;-->
        <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--</div>-->
    <!--</div>-->
  </div>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions'
  import Gravatar from 'vue-gravatar'
  import BrandSelector from 'src/components/Expostat/UserMenu/BrandSelector'
  import EventSelector from 'src/components/Expostat/UserMenu/EventSelector'

  export default {
    components: {
      CollapseTransition,
      Gravatar,
      BrandSelector,
      EventSelector
    },
    data () {
      return {
        isClosed: true
      }
    },
    methods: {
      toggleMenu () {
        this.isClosed = !this.isClosed
      }
    }
  }
</script>
<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }
</style>
